export enum FloorMaterialType {
  STRUCTURE = "STRUCTURE",
  SUBSTRATE_PLYWOOD_SR16 = "SUBSTRATE_PLYWOOD_SR16",
  SUBSTRATE_PLYWOOD_SR24 = "SUBSTRATE_PLYWOOD_SR24",
  SUBSTRATE_PLYWOOD_SR32 = "SUBSTRATE_PLYWOOD_SR32",
  SUBSTRATE_OSB_SR16 = "SUBSTRATE_OSB_SR16",
  SUBSTRATE_OSB_SR32 = "SUBSTRATE_OSB_SR32",
}
//structural material can be extracted in another enum and used along with new  union type
export enum WallMaterialType {
  FOUNDATION = "FOUNDATION",
  STRUCTURE = "STRUCTURE",
  SUBSTRATE = "SUBSTRATE",
  THERMAL = "THERMAL",
  MEMBRANE = "MEMBRANE",
  INTERIOR_FINISH = "INTERIOR_FINISH",
  EXTERIOR_FINISH = "EXTERIOR_FINISH",
  AIRGAP = "AIRGAP",
}
